// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_navbar__rdYhZ {
}
.Navbar_brand__9c58P {
  /* font-size: 1.5rem; */
  font-family: Poppins;
  font-weight: bold;
  color: #ff6500;
  display: flex;
  align-items: center;
}

.Navbar_logo__hXxzZ {
  height: 43px;
  margin-right: 10px;
}

.Navbar_navLink__ULgUO {
  color: #333333;
  margin-right: 0.7rem;
  font-family: Poppins;
  font-size: 15px;
  padding: 0;
  cursor: pointer;
}

.Navbar_navLink__ULgUO:hover {
  color: #333333;
}
.Navbar_getStartedBtn__FuBSu {
  background-color: #ff6500;
  /* border: 1px solid black; */
  color: white;
  font-family: Poppins;
  margin-right: 15px;
  font-size: 16px;
  border-radius: 8px;
  /* transition: background-color 0.3s; */
}

.Navbar_getStartedBtn__FuBSu:hover {
  color: white; /* Hover effect for button */
}
@media (min-width: 300px) and (max-width: 400px) {
  .Navbar_navbar__rdYhZ {
    width: 365px;
  }
}

@media (min-width: 400px) and (max-width: 568px) {
  .Navbar_navbar__rdYhZ {
    width: 420px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/Navbar.module.css"],"names":[],"mappings":"AAAA;AACA;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,YAAY,EAAE,4BAA4B;AAC5C;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".navbar {\n}\n.brand {\n  /* font-size: 1.5rem; */\n  font-family: Poppins;\n  font-weight: bold;\n  color: #ff6500;\n  display: flex;\n  align-items: center;\n}\n\n.logo {\n  height: 43px;\n  margin-right: 10px;\n}\n\n.navLink {\n  color: #333333;\n  margin-right: 0.7rem;\n  font-family: Poppins;\n  font-size: 15px;\n  padding: 0;\n  cursor: pointer;\n}\n\n.navLink:hover {\n  color: #333333;\n}\n.getStartedBtn {\n  background-color: #ff6500;\n  /* border: 1px solid black; */\n  color: white;\n  font-family: Poppins;\n  margin-right: 15px;\n  font-size: 16px;\n  border-radius: 8px;\n  /* transition: background-color 0.3s; */\n}\n\n.getStartedBtn:hover {\n  color: white; /* Hover effect for button */\n}\n@media (min-width: 300px) and (max-width: 400px) {\n  .navbar {\n    width: 365px;\n  }\n}\n\n@media (min-width: 400px) and (max-width: 568px) {\n  .navbar {\n    width: 420px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `Navbar_navbar__rdYhZ`,
	"brand": `Navbar_brand__9c58P`,
	"logo": `Navbar_logo__hXxzZ`,
	"navLink": `Navbar_navLink__ULgUO`,
	"getStartedBtn": `Navbar_getStartedBtn__FuBSu`
};
export default ___CSS_LOADER_EXPORT___;
